import { FC, useCallback, useEffect, useState } from 'react';
import { ScrollView, StyleSheet, View } from 'react-native';
import { Footer } from '../../components/Footer';
import PageTitle from '../../components/PageTitle';
import { Text } from '../../components/Text';
import { useIsDesktop } from '../../hooks/useIsDeskTop';
import BookingCollapse from './components/BookingCollapse';
import { MyBookingsProps } from './types';
import { MAX_WIDTH } from '../../constants/platform';
import MyAccountMenu from '../../components/MyAccountMenu/MyAccountMenu';
import { COLORS, FONTS } from '../../constants';
import { IBooking } from '../../types/bookings.types';
import { AuthApi } from '../../services/api/auth.api';
import { Loading } from '../../components';
import { Button } from '../../components/Button';

const MyBookings: FC<MyBookingsProps> = ({ navigation }) => {
  const isDesktop = useIsDesktop();
  const [page, setPage] = useState<number>(1);
  const [bookings, setBookings] = useState<IBooking[]>([]);
  const [total, setTotal] = useState<number>(0);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const getMyBooking = useCallback(async (pageNumber: number) => {
    setIsLoading(true);
    AuthApi.getMyBooking({ page: pageNumber })
      .then((res) => {
        setBookings(res.data.data.data);
        setTotal(res.data.data.total);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  const handleLoadmore = useCallback(async () => {
    if (bookings.length < total) {
      setPage(Math.ceil(bookings.length / 10) + 1);
      AuthApi.getMyBooking({ page: Math.ceil(bookings.length / 10) + 1 })
        .then((res) => {
          setBookings([...bookings, ...res.data.data.data]);
          setTotal(res.data.data.total);
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  }, [total, bookings]);

  useEffect(() => {
    setPage(1);
    setTotal(0);
    getMyBooking(1);
  }, [getMyBooking]);

  if (isDesktop()) {
    return (
      <ScrollView showsVerticalScrollIndicator={false}>
        <View
          style={{
            maxWidth: MAX_WIDTH,
            width: '90%',
            marginHorizontal: 'auto',
            paddingTop: 40,
            marginBottom: 200,
          }}
        >
          <View
            style={{
              flexDirection: 'row',
              alignItems: 'flex-start',
              justifyContent: 'space-between',
            }}
          >
            <View style={{ width: '22%', minWidth: 230, marginRight: 20 }}>
              <MyAccountMenu />
            </View>
            <View style={{ width: '70%' }}>
              <PageTitle title="MY BOOKINGS" haveGoBackButton={true} />
              <View
                style={{
                  flexDirection: 'column',
                  backgroundColor: COLORS.WHITE,
                  shadowColor: '#F0F0F0',
                  shadowOffset: { width: 0, height: 12 },
                  shadowOpacity: 1,
                  shadowRadius: 32,
                  elevation: 20,
                  borderRadius: 18,
                }}
              >
                <View
                  style={{
                    flexDirection: 'row',
                    paddingHorizontal: 5,
                    backgroundColor: COLORS.RED_PRIMARY,
                    paddingVertical: 13,
                    borderTopLeftRadius: 18,
                    borderTopRightRadius: 18,
                  }}
                >
                  <View
                    style={{
                      width: '25%',
                    }}
                  >
                    <Text style={styles.tableHeaderText}>Date</Text>
                  </View>
                  <View
                    style={{
                      width: '25%',
                    }}
                  >
                    <Text style={styles.tableHeaderText}>Order#</Text>
                  </View>
                  <View
                    style={{
                      width: '22%',
                    }}
                  >
                    <Text style={styles.tableHeaderText}>Total</Text>
                  </View>
                  <View
                    style={{
                      width: '28%',
                    }}
                  >
                    <Text style={styles.tableHeaderText}>Status</Text>
                  </View>
                </View>
                <View
                  style={{
                    flexDirection: 'column',
                    padding: 10,
                  }}
                >
                  {bookings &&
                    bookings.map((item, index) => {
                      return (
                        <View style={{ marginBottom: 15 }}>
                          <BookingCollapse bookingDetail={item} />
                        </View>
                      );
                    })}
                </View>
                {isLoading === false && bookings.length === 0 ? (
                  <View style={styles.noDataWrapper}>
                    <Text style={[styles.noDataText, { fontSize: 20 }]}>
                      THERE ARE CURRENTLY NO BOOKING
                    </Text>
                  </View>
                ) : (
                  <></>
                )}
                {isLoading && <Loading style={{ paddingVertical: 30 }} />}
                {total > bookings.length && (
                  <View
                    style={{
                      marginTop: 10,
                      marginBottom: 35,
                      alignSelf: 'center',
                    }}
                  >
                    <Button
                      text="VIEW MORE"
                      style={{
                        paddingHorizontal: 35,
                        paddingVertical: 12,
                      }}
                      onPress={handleLoadmore}
                      disabled={isLoading}
                      arrowRight={false}
                      textStyle={{
                        textTransform: 'uppercase',
                        fontFamily: FONTS.AvenirMedium,
                        fontWeight: '800',
                        fontSize: 15,
                      }}
                    />
                  </View>
                )}
              </View>
            </View>
          </View>
        </View>
      </ScrollView>
    );
  }

  return (
    <ScrollView showsVerticalScrollIndicator={false}>
      <PageTitle title={'MY BOOKINGS'} haveGoBackButton={true} />
      <View
        style={{
          flexDirection: 'row',
          backgroundColor: COLORS.RED_PRIMARY,
          paddingVertical: 10,
          paddingHorizontal: 10,
        }}
      >
        <View
          style={{
            width: '25%',
          }}
        >
          <Text style={[styles.tableHeaderText, { textAlign: 'left' }]}>
            Date
          </Text>
        </View>
        <View
          style={{
            width: '22%',
          }}
        >
          <Text style={styles.tableHeaderText}>Order#</Text>
        </View>
        <View
          style={{
            width: '25%',
          }}
        >
          <Text style={styles.tableHeaderText}>Total</Text>
        </View>
        <View
          style={{
            width: '25%',
          }}
        >
          <Text style={styles.tableHeaderText}>Status</Text>
        </View>
      </View>
      <View
        style={{
          flexDirection: 'column',
          paddingHorizontal: 5,
          paddingTop: 15,
        }}
      >
        {bookings &&
          bookings.map((item, index) => {
            return (
              <View style={{ marginBottom: 15 }}>
                <BookingCollapse bookingDetail={item} />
              </View>
            );
          })}
      </View>
      {isLoading === false && bookings.length === 0 ? (
        <View style={styles.noDataWrapper}>
          <Text style={[styles.noDataText, { fontSize: 20 }]}>
            THERE ARE CURRENTLY NO BOOKING
          </Text>
        </View>
      ) : (
        <></>
      )}
      {isLoading && <Loading style={{ paddingVertical: 30 }} />}
      {total > bookings.length && (
        <View
          style={{
            marginTop: 10,
            marginBottom: 35,
            alignSelf: 'center',
          }}
        >
          <Button
            text="VIEW MORE"
            style={{
              paddingHorizontal: 35,
              paddingVertical: 12,
            }}
            onPress={handleLoadmore}
            disabled={isLoading}
            arrowRight={false}
            textStyle={{
              textTransform: 'uppercase',
              fontFamily: FONTS.AvenirMedium,
              fontWeight: '800',
              fontSize: 15,
            }}
          />
        </View>
      )}
      <Footer />
    </ScrollView>
  );
};

export default MyBookings;

const styles = StyleSheet.create({
  tableHeaderText: {
    fontFamily: FONTS.AvenirMedium,
    fontWeight: '500',
    fontSize: 16,
    letterSpacing: 1.5,
    textTransform: 'uppercase',
    color: COLORS.WHITE,
    textAlign: 'center',
  },
  noDataWrapper: {
    flexDirection: 'row',
    justifyContent: 'center',
    paddingBottom: 20,
    width: '100%',
  },
  noDataText: {
    color: COLORS.BLACK,
    textTransform: 'uppercase',
    fontFamily: FONTS.AvenirRegular,
    textAlign: 'center',
  },
});
